import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import whatInput from 'what-input';
const SelectorItem = (props) => {
    const { t } = useTranslation();
    const CLASSNAME = 'selector__item__radio';
    const isDisabled = props.disabled && !props.isBoutiqueExclusive;
    return (React.createElement("div", { className: classNames(CLASSNAME, 'selector__menu__item', isDisabled && 'is-disabled', props.selected && 'selected', props.isInverted && 'inverted') },
        React.createElement("input", { className: "selector-size-item__input", type: "radio", id: `${props.selectorId}_${props.value}`, value: props.value, name: `size-selector-${props.selectorId}`, "aria-label": isDisabled ? t('selector.option.notavailable', { 0: props.label }) : props.label, onChange: () => {
                props.onSelect && props.onSelect(props.item, whatInput.ask() !== 'keyboard');
            }, onBlur: (e) => {
                var _a;
                if (whatInput.ask() === 'keyboard' && !((_a = e.relatedTarget) === null || _a === void 0 ? void 0 : _a.parentElement.classList.contains(CLASSNAME))) {
                    props.onSelect && props.onSelect(props.item, true);
                }
            }, disabled: !props.isNotAvailableSelectable && isDisabled, checked: props.selected ? true : false }),
        React.createElement("label", { htmlFor: `${props.selectorId}_${props.value}`, className: classNames('selector__menu__item__label'), "aria-hidden": true },
            props.label,
            props.enableOutofstockLabel && props.isOutOfStock ? ` - ${t('label.outofstock')}` : ''),
        props.children));
};
SelectorItem.defaultProps = {
    enableOutofstockLabel: true,
    isNotAvailableSelectable: true,
    isInverted: false,
};
export default SelectorItem;
